<template>
  <div id="app">
    <!-- <button>test</button> -->
   <TopMenu />
  <transition  enter-active-class="animated animate__animated animate__faster animate__fadeIn" leave-active-class="animated animate__faster animate__animated animate__fadeOut" mode="out-in">
      <keep-alive>
        <router-view :key="$route.meta.key"/>
      </keep-alive>
    </transition>
       <SVGBack />
  </div>
</template>

<script>
import Navigation from '@/components/Navigation.vue'
import SVGBack from '@/components/SVGAnimation.vue'
import TopMenu from '@/components/TopMenu.vue'
export default {
  name: 'app',
  components:{
    Navigation,
    SVGBack,
    TopMenu,
  },
  methods: {
    handleScroll(e){
      if (window.scrollY > 0){
        document.body.classList.add('scrolling')
      }else{
        document.body.classList.remove('scrolling')
      }
    },
    winSize(){
      console.log('WINDOW SIZE')
      // We execute the same script as before
      let vh = window.innerHeight * 0.01;

      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }
  },
  created () {
    this.winSize()
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('load', this.handleScroll)
    window.addEventListener('resize', this.winSize)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('load', this.handleScroll)
    window.removeEventListener('resize', this.winSize);
  },
}
</script>


<style>
#app {
  font-family: 'Roboto', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  /* min-height: 100vh;  */
  min-height: calc(var(--vh, 1vh) * 100);
  /* height: 100%; */
  color: #2c3e50;
  position: relative;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .35s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.box {
  z-index: 2;
}

.background-block{
  /* display: none; */
}


.view-wrap{
  z-index: 1;
  position: relative;
}
/* 
.fade-enter-active, .fade-leave-active {
  transition: opacity .25s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.router-anim-leave-to{
    position: absolute;
    width: 100%;
} */

.slideMain-leave-active,
.slideMain-enter-active {
  transform: translateX(0);
  transition: all .5s linear;
}
.slideMain-enter {
  transform: translateX(100%);
}
.slideMain-leave-to {
  transform: translate(-100%, 0); 
}

body{
  /* background: #000; */
}

.body-slide-open {
    overflow-y: hidden;
}


    /* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-josh-enter-active {
  transition: all .75s ease;
}
.slide-josh-leave-active {
  transition: all .25s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  position: absolute;
}
.slide-josh-enter
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(100%);
  opacity: 0;
}

.reverse .slide-josh-enter{
    transform: translateX(-100%);
}

.reverse .slide-josh-leave-to{
    transform: translateX(100%);
}

.slide-josh-leave-to{
    position: absolute;
    transform: translateX(-100%);
}
</style>